export default "__VITE_ASSET__c4dc14eb__"